import React, { useState, useEffect } from 'react';
import './Services.css';
import Gallery from '../Gallery/Gallery';
import portfolios from './portfolio-db';

const images = [
    "/images/portfolio-1.png",
    "/images/portfolio-2.png",
    "/images/portfolio-3.png"
];

function Services() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeChip, setActiveChip] = useState(1);  // Assuming 'Titus' (chip 2) is the default active chip

    const handleCarouselChange = (currentSlideIndex) => {
        setActiveChip(currentSlideIndex + 1); // +1 because your chips start from 1, not 0
    }

    const prevSlide = () => {
        const lastIndex = images.length - 1;
        const newCurrentIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
        setCurrentIndex(newCurrentIndex);
        handleCarouselChange(newCurrentIndex);
    };

    const nextSlide = () => {
        const newCurrentIndex = (currentIndex + 1) % images.length;
        setCurrentIndex(newCurrentIndex);
        handleCarouselChange(newCurrentIndex);
    };

    const currentPortfolio = portfolios[currentIndex];

    // Parte com as colunas

    const [scrollY, setScrollY] = useState(0);
    const movementFactor = 0.25;

    const columnMultipliers = [
        0.2,
        0.001,
        0.25,
        0.15
    ];

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    return (
        <>
        <div className="services">
            <div className="services-background-columns">
            <div className="column column1" 
                    style={{ height: `${0 + Math.min(scrollY * movementFactor * columnMultipliers[0], 90)}%` }}>
                </div>
                <div className="column column2" 
                    style={{ height: `${0 + Math.min(scrollY * movementFactor * columnMultipliers[1], 90)}%` }}>
                </div>
                <div className="column column3" 
                    style={{ height: `${0 + Math.min(scrollY * movementFactor * columnMultipliers[2], 90)}%` }}>
                </div>
                <div className="column column4" 
                    style={{ height: `${0 + Math.min(scrollY * movementFactor * columnMultipliers[3], 90)}%` }}>
                </div>

            </div>
            <div className="services-content">
                <div className="services-carousel">
                    <div className="carousel-container">
                        <img src={images[currentIndex]} alt="Portfolio Slide" className="carousel-image" />
                    </div>
                    <button className="carousel-button carousel-button-left" onClick={prevSlide}>
                        <img src="/icons/chevron-left.svg" alt="Previous" />
                    </button>
                    <button className="carousel-button carousel-button-right" onClick={nextSlide}>
                        <img src="/icons/chevron-right.svg" alt="Next" />
                    </button>
                </div>
            <div className="chips-container">
                {portfolios.map((portfolio, index) => (
                    <div key={index} className={`chip chip-${index + 1} ${activeChip === index + 1 ? 'active' : ''}`}>
                        {portfolio.company}
                    </div>
                ))}
            </div>
            <div className="content-container-services">
                <div className="client-container">
                    <p>{currentPortfolio.location}</p>
                    <h3 style={{marginTop: "0px", marginBottom: "0px"}}>{currentPortfolio.company}</h3>
                    <div className="provided-services">
                        {/* Note: If "Servicios" details are specific to each portfolio, you need to add them in the database */}
                        <p className="semi-bold">Servicios:</p>
                        <div className={`chip chip-1 active`}>Audiovisual</div>
                        <div className={`chip chip-2 active`}>Marketing</div>
                        <div className={`chip chip-3 active`}>Tecnologia</div>
                    </div>
                    <p className="client-description" style={{marginTop: "0px", marginBottom: "0px"}}>
                        {currentPortfolio.description}
                    </p>
                    <p className="elenco-title" style={{marginTop: "4%", marginBottom: "0px"}}>Elenco</p>
                    <ul className="elenco-list">
                        {currentPortfolio.elenco.map((member, index) => (
                            <li key={index}>{member}</li>
                        ))}
                    </ul>
                </div>

                <div className="gallery-container">
                    <p className="subline">GALERIA</p>
                    <Gallery currentIndex={currentIndex} />
                </div>
            </div>
            </div>
        </div>
        </>
    );
}

export default Services;